import { redirect } from "react-router";
import { apiClient } from "~/api/api-client";
import { env } from "~/env";
import { authService } from "./auth-service";
import { CSRF_TOKEN_COOKIE, setCookie } from "./cookie";

async function getCsrfToken() {
  // Always get CSRF token from API. That way, if we need to override it with
  // env variable, we already have a request response with the token in the
  // network tab of developer tools.
  await apiClient.GET("/auth/csrf-token");
  if (env.VITE_CSRF_TOKEN_OVERRIDE) {
    setCookie(CSRF_TOKEN_COOKIE, env.VITE_CSRF_TOKEN_OVERRIDE);
  }
}

// Runs before loaders and before tenant-context-middleware
// Ensures user is authenticated before setting tenant context
export const authMiddleware = async ({ request }: { request: Request }) => {
  await authService.ensureInitialized();

  const url = new URL(request.url);
  if (url.pathname === "/auth/callback") {
    return;
  }
  const isAuthenticated = authService.isAuthenticated();
  if (!isAuthenticated) {
    throw redirect(authService.getLoginUrl() || "/");
  }

  await getCsrfToken();
};
